import axios from 'axios';
import auth from '../utils/auth';
import Logger from '../toolkit/logger/Logger';

const noRedirectUnAuthorize = [
  /\/api\/collections$/,
  /\/api\/users\/login-alternate$/,
  /\/api\/users\/.+\/password$/
];

axios.interceptors.response.use(null, error => {
  const response = error.response;
  if (response && response.status) {
    Logger.log('Axios::Interceptors');
    if (response.status === 401) {
      for (const item of noRedirectUnAuthorize) {
        const noRedirect = item.test(response.config.url);
        if (noRedirect) {
          return Promise.reject(error);
        }
      }
      const token = auth.getJwt();
      if (token) {
        window.location.href = '/logout';
      }
    }
  }
  return Promise.reject(error);
});

export const resetToken = () => {
  axios.defaults.headers.common['x-access-token'] = auth.getJwt();
}

resetToken();

export const REACT_APP_URL_ROOT = process.env.REACT_APP_API_ROOT || '';
export const API_URL = REACT_APP_URL_ROOT + '/api';
export default axios;
